import { render, staticRenderFns } from "./platticketrecord.vue?vue&type=template&id=0c426b84&"
import script from "./platticketrecord.vue?vue&type=script&lang=js&"
export * from "./platticketrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports